import React from 'react';
import { ConfiguableSvgProps } from './types';

const VolumeIcon = ({
	width = '16',
	height = '16',
	...props
}: ConfiguableSvgProps) => {
	return (
		<svg
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				d="M13.333 4.66659H10.6663V2.66659C10.6663 1.93125 10.0683 1.33325 9.33301 1.33325H6.66634C5.93101 1.33325 5.33301 1.93125 5.33301 2.66659V5.99992H2.66634C1.93101 5.99992 1.33301 6.59792 1.33301 7.33325V13.3333C1.33301 13.5101 1.40325 13.6796 1.52827 13.8047C1.65329 13.9297 1.82286 13.9999 1.99967 13.9999H13.9997C14.1765 13.9999 14.3461 13.9297 14.4711 13.8047C14.5961 13.6796 14.6663 13.5101 14.6663 13.3333V5.99992C14.6663 5.26459 14.0683 4.66659 13.333 4.66659ZM2.53 7.19H5.4V12.8H2.53V7.19ZM6.6 2.53H9.4V12.8H6.6V2.53ZM13.47 12.8H10.6V5.86H13.47V12.8Z"
				fill={props.color}
			/>
		</svg>
	);
};

export default VolumeIcon;
